// "Playing since October 2026": when the account was made. Older accounts
// without created_at fall back to the time inside their Mongo id. An account
// reset to a new player counts from the reset.
export function playingSince(user) {
  const since = user?.stats_reset_at || user?.created_at;
  let d = since ? new Date(since) : null;
  if ((!d || isNaN(d)) && /^[0-9a-f]{24}$/i.test(user?.id || "")) {
    d = new Date(parseInt(user.id.slice(0, 8), 16) * 1000);
  }
  if (!d || isNaN(d)) return null;
  return d.toLocaleDateString(undefined, { month: "long", year: "numeric" });
}
